module.exports = __webpack_public_path__ + "img/capa1.ced5d3e4.webp";